import Utils from '../../utils/Utils';
import ObjReg from '../../utils/ObjReg';
import PSA from '../../psa';

function handleLeave(evt, cldCmp) {
	const from = evt.relatedTarget || evt.toElement;
	if ( from && from.nodeName ) {
		return;
	}
	if ( cldCmp.rowReg ) {
		cldCmp.rowReg.forEach(grcRow => {
			if ( grcRow.drgCi && grcRow.isCi ) {
				clrCiPrp(grcRow, grcRow.drgCi);
				delete grcRow.mosXbeg;
				delete grcRow.mosYbeg;
				delete grcRow.mosXend;
				delete grcRow.mosYend;
			}
		});
	}
	if ( !cldCmp || !cldCmp.movApmOvl ) {
		return;
	}
	const ovl = cldCmp.movApmOvl;
	cldCmp.movApmOvl = null;
	if ( !cldCmp.parDiv ) {
		return;
	}
	ovl ? cldCmp.parDiv.removeChild(ovl) : void 0;
}

function clrCiPrp(scope, ci) {
	if ( !scope && !ci ) {
		return;
	}
	scope ? scope.isCi = false : void 0;
	scope ? scope.drgCi = null : void 0;
	scope ? scope.isVrt = false : void 0;
	scope ? scope.curRow = null : void 0;
	if ( !ci ) {
		return;
	}
	ci.mosDwn = false;
	ci.mosXstr = null;
	ci.mosXend = null;
	ci.apmXstr = null;
	ci.apmXend = null;
	ci.apmXWdt = null;
	ci.apmStlWdt = null;
	ci.mosYend = null;
	ci.apmYstr = null;
	ci.apmYend = null;
	ci.apmYHgt = null;
	ci.isAtMrg = null;
}

export default class GrcCmp {

	constructor(properties) {
		Utils.bindAll(this, [ "onRender" ]);
		const idw = properties.parent || '';
		this.wdgId = idw;
		this.parent = rap.getObject(idw);
		this.ready = false;
		this.parDiv = null;
		this.apmOvl = null;
		this.rowReg = new ObjReg();
		this.awayLsr = null;
		this.ruler = null;
		rap.on("render", this.onRender);
	}

	destroy() {
		this.ready = false;
		if ( this.wdgId ) {
			PSA.getInst().glbWdgReg.rmvObj(this.wdgId);
		}
		if ( this.awayLsr ) {
			window.document.removeEventListener('mouseout', this.awayLsr);
			delete this.awayLsr;
		}
		this.rmvApmOvl();
		this.rowReg.destroy();
		this.rowReg = null;
		this.ruler = null;
	}

	onRender() {
		rap.off("render", this.onRender);
		this.parDiv = this.parent.$el.get(0) || null;
		this.ready = (this.parDiv !== null);
		if ( this.ready && this.wdgId ) {
			PSA.getInst().glbWdgReg.addObj(this.wdgId, this);
			const away_lsr = (e) => {
				handleLeave(e, this);
			};
			this.awayLsr = away_lsr;
			window.document.addEventListener('mouseout', this.awayLsr);
		}
	}

	addRow(row) {
		this.rowReg.addObj(row.getIdw(), row);
	}

	rmvRow(row) {
		if ( this.rowReg ) {
			this.rowReg.rmvObj(row.getIdw());
		}
	}

	setRuler(rlr) {
		this.ruler = rlr;
	}

	shoApmOvl(args) {
		this.rmvApmOvl();
		if ( !this.ready || !this.rowReg ) {
			return;
		}
		const row = this.rowReg.getFirst();
		if ( !row || !args || !args.beg || !args.end ) {
			return;
		}
		const ovl = this._crtOvlElm(args, row);
		this.parDiv.appendChild(ovl);
		this.apmOvl = ovl;
	}

	_crtOvlElm(args, row) {
		const cor = this._clcCor(row, args.beg);
		const ovl = document.createElement('div');
		this._setElmUi(ovl);
		ovl.style.marginLeft = `${this._getLftAndWdt(row, args.beg, args.end, cor).lft}%`;
		ovl.style.width = `${this._getLftAndWdt(row, args.beg, args.end, cor).wdt}%`;
		ovl.style.height = `${this._clcOvlHgt(row)}px`;
		return ovl;
	}

	_getLftAndWdt(row, beg, end, cor) {
		const stlLft = cor * 100.0 * (beg - row.prdBeg) / (row.prdEnd - row.prdBeg);
		const stlWdt = cor * 100.0 * (end - beg) / (row.prdEnd - row.prdBeg);
		return { lft: stlLft, wdt: stlWdt };
	}

	_setElmUi(elm) {
		elm.style.position = "absolute";
		elm.style.zIndex = "3000";
		elm.style.backgroundColor = "rgba(0, 150, 136, 0.4)";
		elm.style.borderColor = "rgb(0, 150, 136)";
		elm.style.borderWidth = "0.5px";
		elm.style.borderStyle = "solid";
	}

	_clcCor(row, beg) {
		const blk = row._fndBlk(beg);
		if ( !blk ) return 1.0;
		const rct = row.row.getBoundingClientRect();
		return row._getCorFct(blk.div, blk.tms, rct.width, rct.left);
	}

	_clcOvlHgt(row) {
		if ( !this.rowReg ) {
			return 0;
		}
		const rowCnt = this.rowReg.size();
		return rowCnt * row.row.getBoundingClientRect().height;
	}

	rmvApmOvl() {
		if ( this.apmOvl ) {
			const ovl = this.apmOvl;
			this.apmOvl = null;
			this.parDiv.removeChild(ovl);
		}
	}

	static register() {
		rap.registerTypeHandler("pisasales.GrcCmp", {
			factory: function(properties) {
				return new GrcCmp(properties);
			},
			destructor: "destroy",
			properties: [],
			methods: [ "shoApmOvl", "rmvApmOvl" ],
			events: [ "GRC_CMP_NFY" ]
		});
	}
}
